import { useQuery } from '@tanstack/react-query';

import { RequestConfig } from '~/common/services/requests';
import { Module } from '../../../../../constants';
import { useTenantedApplicationConfig } from '../../../../../contexts';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { buildIncludeParams } from '../../../../logic/buildIncludeParams';
import { unwrapPaginatedResponseDataAs } from '../../../../logic/unwrapPaginatedResponseDataAs';
import { APPLICATION_BASE_PATH } from '../../constants/applicationBasePath';
import { getApplicationQueryResults } from '../../requests/getApplicationQueryResults';

export const useApplicationQueryResults = (
  uuid: string,
  definition: string,
  query: string,
  searchParams: RequestConfig['params'],
) => {
  const { constructGet } = useRequestConstructor();
  const config = useTenantedApplicationConfig();

  const params = {
    ...(searchParams as Record<string, string>),
    ...buildIncludeParams([
      ...(query === 'related-deals' ? ['asset', 'quote'] : []),
      'status',
    ]),
    query,
  };

  const { modules } = config.documents[definition];
  const { statusDefinition } = modules[Module.MiddleOffice].primaryWorkflow;

  const { data, refetch, ...rest } = useQuery<
    Awaited<ReturnType<typeof getApplicationQueryResults>>
  >({
    queryKey: [
      APPLICATION_BASE_PATH,
      uuid,
      'queries',
      params,
      statusDefinition,
    ],
    queryFn: () =>
      getApplicationQueryResults(
        constructGet,
        uuid,
        definition,
        params,
        statusDefinition,
      ),
    enabled: Boolean(uuid),
  });

  return {
    ...unwrapPaginatedResponseDataAs(data, refetch, 'queryResults'),
    ...rest,
  };
};
